import React from "react";

import { motion } from "framer-motion";

const ChartCard = ({
  title,
  subtitle,
  children,
  loading,
  error,
  action,
  className,
}) => (
  <motion.div
    animate={{ opacity: 1, scale: 1 }}
    className={`bg-white dark:bg-gray-800/30 rounded-lg p-6 ${className || ""}`}
    initial={{ opacity: 0, scale: 0.95 }}
  >
    {/* Header */}
    {(title || action) && (
      <div className="flex items-start justify-between mb-4">
        <div>
          {title && (
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              {title}
            </h3>
          )}
          {subtitle && (
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
              {subtitle}
            </p>
          )}
        </div>
        {action && <div className="flex-shrink-0 ml-4">{action}</div>}
      </div>
    )}

    {/* Body */}
    {loading ? (
      <div className="h-[300px] rounded-lg animate-pulse bg-gray-200 dark:bg-gray-700" />
    ) : error ? (
      <div className="flex flex-col items-center justify-center h-[300px] text-center">
        <p className="text-red-500 dark:text-red-400 text-sm">{error}</p>
      </div>
    ) : (
      children
    )}
  </motion.div>
);

export default ChartCard;
